import * as service from './service'
export default {
  namespace: 'dalianProve',
  state: {
    proveData: {}
  },
  effects: {

    * getProveData ({ payload }, { call, put }) {
      const res = yield call(service.getProveData, payload)
      yield put({
        type: 'save',
        payload: {
          proveData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
